import React from 'react';

const EmailInput = ({ question, value, onChange, error }) => {
  return (
    <div className="question-input">
      <input
        type="email"
        value={value || ''}
        onChange={(e) => onChange(e.target.value)}
        placeholder={question.placeholder}
        className={`quiz-input ${error ? 'error' : ''}`}
        required={question.required}
      />
      {error && <span className="error-message">{error}</span>}
    </div>
  );
};

export default EmailInput;